const mobileLicensingQueryKeys = {
  all: ['mobile-licensing'] as const,
  detail: () => [...mobileLicensingQueryKeys.all, 'detail'] as const,
};

export default mobileLicensingQueryKeys;
